import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type MiniProfile } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MiniProfile.Api.InitRequest
  ): Promise<HttpApiResponse<MiniProfile.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/miniProfile`, args)
};
